import axios, { AxiosResponse } from 'axios';
import { GetSupplierListResponseDto } from '@ce-openapi/purchase-order-view-service-api-documentation-ts-axios-client';
import {
  V1_EXPORT_SUPPLIER,
  V1_SUPPLIER_BY_ID,
  V1_SUPPLIER,
  V1_REACTOR_SUPPLIER,
  V1_REACTOR_SUPPLIER_BY_ID,
  V1_PURCHASE_ORDER_SUPPLIER,
} from './constants';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function reject(error, name?: string) {
  let eobj;

  if (error.response) {
    const { data } = error.response;

    if (data.code && data.code === '0010-0001') {
      eobj = new Error(`Supplier does not found or already removed`);
    } else if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }

  return Promise.reject(eobj);
}

export function getSuppliers(params) {
  return axios
    .get(V1_SUPPLIER, { params, withCredentials: true })
    .catch(reject);
}

type GetPurchaseOrderSuppliersParams = {
  cursor?: string;
  keyword?: string;
  per_page?: number;
};

export function getPurchaseOrderSuppliers(
  params: GetPurchaseOrderSuppliersParams
): Promise<AxiosResponse<GetSupplierListResponseDto>> {
  return axios
    .get(V1_PURCHASE_ORDER_SUPPLIER, { params, withCredentials: true })
    .catch(reject);
}

export function getExportSupplier(email, keyword) {
  const params = { email, keyword };
  return axios
    .get(V1_EXPORT_SUPPLIER, { params, withCredentials: true })
    .catch(reject);
}

export function deleteReactorSupplier(id, name, params) {
  return axios
    .delete(V1_REACTOR_SUPPLIER_BY_ID(id), { params, withCredentials: true })
    .catch((error) => reject(error));
}

export function deleteSupplier(id, name, params) {
  return axios
    .delete(V1_SUPPLIER_BY_ID(id), { params, withCredentials: true })
    .catch((error) => reject(error, name));
}

export function putReactorSupplier(id, data, params) {
  return axios
    .put(V1_REACTOR_SUPPLIER_BY_ID(id), data, {
      params,
      withCredentials: true,
    })
    .catch((error) => reject(error));
}

export function putSupplier(id, data, params) {
  return axios
    .put(V1_SUPPLIER_BY_ID(id), data, { params, withCredentials: true })
    .catch((error) => reject(error, data.name));
}

export function postReactorSuppliers(data, params) {
  return axios
    .post(V1_REACTOR_SUPPLIER, data, { params, withCredentials: true })
    .catch(reject);
}

export function postSuppliers(data, params) {
  return axios
    .post(V1_SUPPLIER, data, { params, withCredentials: true })
    .catch(reject);
}
